import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import deviceDOMHoc from '../../../hocs/deviceDOMHoc';
import { MeteredMaterialType } from '../../../constants/MaterialModels';
import PumpDevice from './PumpDevice';
import PumpBottleDevice from './PumpBottleDevice';

@inject('materialStore', 'batchStore')
@observer
class Pump extends Component {
  render() {
    const { device, materialStore, batchStore } = this.props;
    const material = materialStore.materials.find(v => v.pumpId === device.id);
    const materialDetails = material ? materialStore.materialDetails[material.materialDetailId] : null;
    const type = materialDetails ? materialDetails.type : null;

    const onPush = () => {
      batchStore.onPumpButtonPress({ ...device });
    };

    const onPushUp = () => {
      return batchStore.onPumpButtonRelease({ ...device });
    };

    if (type === MeteredMaterialType.Water || type === MeteredMaterialType.SecondWater || device.tankId) {
      return (
        <PumpDevice {...this.props} material={material} onPush={onPush}
          onPushUp={onPushUp} />
      );
    }

    return (
      <PumpBottleDevice {...this.props} material={material} onPush={onPush}
        onPushUp={onPushUp}/>
    );
  }
}

export default deviceDOMHoc(Pump);
